<template>
  <div :style="open ? 'z-index:4' : ''">
    <div
      class="f-center anim-fade-in_slow"
      style="
        transform: scale(1.3);
        --size: 5.5rem;
        --size-inner: 5rem;
        height: var(--size);
        width: var(--size);
        border-radius: 4px;
        background: var(--clr-black-0-3);
        box-shadow: var(--menu-shadow);
      "
      @click="open = !open"
    >
      <div
        class="icon_btn pa-2 text-ultra"
        style="height: var(--size-inner); width: var(--size-inner)"
      >
        <Pepehelp style="height: 100%; width: 100%" />
      </div>
    </div>
    <div
      v-show="open"
      class="gw_menu anim-fade-in"
      style="
        user-select: text;
        background: var(--clr-black-0-3);
        width: 32rem;
        position: absolute;
        transform: translate(-100%, -100%);
        top: -1rem;
        left: 100%;
      "
    >
      <div style="">
        <div class="weight_700 text-semi-large mb-4">
          {{ $t('common.need_help') }}
        </div>
        <NavBox style="min-height: 36rem">
          <template #root="v">
            <div
              class="f-column"
              style="gap: 0.25rem; overflow: auto"
            >
              <div
                v-for="(item, idx) in items"
                :key="item.id + idx"
                class="gw_btn_hover_back cursor-pointer f-center px-2 py-1 weight_500 clr-grey"
                @click="
                  () => {
                    aaItem = item
                    v.goForward('content')
                  }
                "
              >
                <div class="mdi mdi-chevron-right text-semi-large line-height_1 mr-2"></div>
                <div
                  class="mr-auto"
                  v-html="item.title"
                ></div>
              </div>
            </div>
          </template>
          <template #content="v">
            <div
              v-if="aaItem"
              class="f-column"
              style="min-height: 0"
            >
              <div
                class="gw_btn_hover_back cursor-pointer f-center px-2 py-1 weight_500 clr-white"
                style="position: sticky; top: 0; z-index: 4"
                @click="v.goBackward('root')"
              >
                <div class="mdi mdi-chevron-left text-semi-large line-height_1 mr-2"></div>
                <div
                  class="ml-1 weight_500 mr-auto"
                  v-html="aaItem.title"
                ></div>
              </div>
              <div
                class="mt-2 pa-1"
                style="overflow: auto; min-height: 0"
              >
                <div
                  class="clr-grey"
                  style="--title-weight: 700"
                  v-html="aaItem.text"
                ></div>
                <div
                  v-if="aaItem.videoId"
                  class="mt-2"
                >
                  <GwVideoPlayer
                    autoplay
                    type="youtube"
                    class="mt-4"
                    style="border-radius: 12px; overflow: hidden; min-height: 166px"
                    :isVisible="open"
                    :src="aaItem.videoId"
                    @click.stop
                  />
                </div>
                <a
                  v-if="aaItem.learnMoreUrl"
                  class="weight_700 text-underline_hover mt-2"
                  :href="aaItem.learnMoreUrl"
                  target="_blank"
                  v-html="$t('common.learn_more')"
                >
                </a>
                <div
                  v-if="aaItem.text_bottom"
                  class="clr-grey mt-2"
                  v-html="aaItem.text_bottom"
                ></div>
                <!-- <div v-if="hasLinkToTiers">hasLinkToTiers</div> -->
              </div>
            </div>
          </template>
        </NavBox>
      </div>
      <div
        class="mdi mdi-close icon_btn pa-1"
        data-tst="solfigr_steps_help_close"
        style="position: absolute; top: 0.5rem; right: 0.5rem"
        @click="close()"
      ></div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import NavBox from '@/components/NavBox/NavBox'
import Pepehelp from '@/assets/svg/pepe_help.svg'
import float_mix from '@/mixins/float_mix'
import links_mix from '@/mixins/links_mix'
import GwVideoPlayer from '@/components/lib/GwVideoPlayer'

export default {
  name: 'SolfigrStepsHelp',
  components: {
    GwVideoPlayer,
    Pepehelp,
    NavBox,
  },
  mixins: [float_mix, links_mix],
  props: {},
  data() {
    return {
      open: false,
      aaItem: null,
    }
  },
  mounted() {
    if (localStorage.getItem('solfigrStepsHelpClosed')) return
    nextTick(() => {
      setTimeout(() => {
        this.open = true
      }, 1000)
    })
  },
  methods: {
    close() {
      this.open = false
      localStorage.setItem('solfigrStepsHelpClosed', 'closed')
    },
  },
  computed: {
    items() {
      const cssClass = 'weight_500 text-underline_hover'

      const res = [
        { id: 'custom_solving', videoId: 'mi5F1-69QOw' },
        {
          id: 'try_custom_solving',
          hasLinkToTiers: true, // todo
        },
        {
          id: 'upcoming_features_and_limitations',
          textProps: {
            stackpot_ratio: this.$i18n.g1
              ? this.$t(`solfigr.help.stackpot_ratio`)
              : this.$t('common.link_text', {
                  url: 'https://blog.gtowizard.com/stack-to-pot-ratio/',
                  cssClass,
                  text: this.$t(`solfigr.help.stackpot_ratio`),
                }),
          },
        },
        {
          id: 'choose_board_cards',
          hasLinkToTiers: true, // todo
        },
        { id: 'prefill_spot' },
        { id: 'customize_ranges' },
        {
          id: 'customize_bet_sizes',
          textProps: {
            percentage_pot: this.$i18n.g1
              ? this.$t(`solfigr.help.percentage_pot`)
              : this.$t('common.link_text', {
                  url: this.links_url_links.geometric_betting.url,
                  cssClass,
                  text: this.$t(`solfigr.help.percentage_pot`),
                }),
            geometric_size: this.$i18n.g1
              ? this.$t(`solfigr.help.geometric_size`)
              : this.$t('common.link_text', {
                  url: this.links_url_links.learn_more_solfigr_sizes_tooltip.url,
                  cssClass,
                  text: this.$t(`solfigr.help.geometric_size`),
                }),
          },
        },

        {
          id: 'simplify_strategy',
          learnMoreUrl: 'https://blog.gtowizard.com/gto-wizard-ai-explained/',
        },
        { id: 'automatic_dynamic_fixed_bet_sizes' },
        { id: 'tree_node_editing' },
        {
          id: 'save_load_parameters',
          textProps: {
            how_to_organize_with_tags: this.$i18n.g1
              ? this.$t(`solfigr.help.how_to_organize_with_tags`)
              : this.$t('common.link_text', {
                  url: 'https://blog.gtowizard.com/simplified-solutions-and-a-new-interface/#tags_for_saved_filters',
                  cssClass,
                  text: this.$t(`solfigr.help.how_to_organize_with_tags`),
                }),
          },
        },
        { id: 'previously_solved_spots' },
        {
          id: 'solution_accuracy',
          textProps: {
            top_benchmarks: this.$i18n.g1
              ? this.$t(`solfigr.help.top_benchmarks`)
              : this.$t('common.link_text', {
                  url: 'https://blog.gtowizard.com/gto-wizard-ai-benchmarks/',
                  cssClass,
                  text: this.$t(`solfigr.help.top_benchmarks`),
                }),
            slumbot: this.$i18n.g1
              ? this.$t(`solfigr.help.slumbot`)
              : this.$t('common.link_text', {
                  url: 'https://blog.gtowizard.com/crushing-a-top-hunl-poker-bot/',
                  cssClass,
                  text: this.$t(`solfigr.help.slumbot`),
                }),
          },
        },
        {
          id: 'additional_resources',
          videoId: 'mi5F1-69QOw',
          text_bottom: this.$t(`solfigr.help.additional_resources_text_bottom_tra01`, {
            mailto: 'mailto:hello@gtowizard.com?subject=Subscription',
            email: 'hello@gtowizard.com',
            introducing: this.$i18n.g1
              ? this.$t(`solfigr.help.introducing`)
              : this.$t('common.link_text', {
                  url: 'https://blog.gtowizard.com/introducing-gto-wizard-ai/',
                  cssClass,
                  text: this.$t(`solfigr.help.introducing`),
                }),
            benchmarks: this.$i18n.g1
              ? this.$t(`solfigr.help.benchmarks`)
              : this.$t('common.link_text', {
                  url: 'https://blog.gtowizard.com/gto-wizard-ai-benchmarks/',
                  cssClass,
                  text: this.$t(`solfigr.help.benchmarks`),
                }),
            solver_explained: this.$i18n.g1
              ? this.$t(`solfigr.help.solver_explained`)
              : this.$t('common.link_text', {
                  url: 'https://blog.gtowizard.com/gto-wizard-ai-explained/',
                  cssClass,
                  text: this.$t(`solfigr.help.solver_explained`),
                }),
            crushing_bot: this.$i18n.g1
              ? this.$t(`solfigr.help.crushing_bot`)
              : this.$t('common.link_text', {
                  url: 'https://blog.gtowizard.com/crushing-a-top-hunl-poker-bot/',
                  cssClass,
                  text: this.$t(`solfigr.help.crushing_bot`),
                }),
            pricing: this.$i18n.g1
              ? this.$t(`solfigr.help.pricing`)
              : this.$t('common.link_text', {
                  url: 'https://app.gtowizard.com/subscription/tier-overview',
                  cssClass,
                  text: this.$t(`solfigr.help.pricing`),
                }),
          }),
        },
      ].map(i => ({
        ...i,
        title: this.$t(`solfigr.help.${i.id}`),
        text: this.$t(`solfigr.help.${i.id}_text`, i.textProps || {}),
      }))
      return res
    },
  },
}
</script>
